// faqReducer.ts
import axios from 'axios';
import { Dispatch } from 'redux';

// Action Types
const GET_CMS_ENTRY_DATA_FAQ = 'GET_CMS_ENTRY_DATA_FAQ';

// Action Interfaces
interface GetCmsEntryDataAction {
    type: typeof GET_CMS_ENTRY_DATA_FAQ;
    payload: {
        key: string;
        data: CmsEntryData[];
    };
}
  
// Define the CmsEntryData type
interface CmsEntryData {
    data: any;
    title: string;
    content: string;
    // Add other fields as necessary
}

export const getCmsEntryDataFaq = (content_cms: string, language: string, key: string) => async (dispatch: Dispatch<GetCmsEntryDataAction>) => {
    try {
        const response = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/cms/entry/dataByCmsAndLanguage`, {
          params: { content_cms, language }
        });

        if (response.data) {
            dispatch({
                type: GET_CMS_ENTRY_DATA_FAQ,
                payload: {
                    key,
                    data: response.data,
                },
            });
        } else {
            // Handle the case when data is not available
            // You can dispatch another action or handle it as needed
        }
    } catch (error) {
        console.error('Error fetching CMS entry data:', error);
        // You can dispatch an error action or handle it as needed
    }
};

// State Type
interface FaqState {
  faq: { [key: string]: CmsEntryData[] } | null; // Now typed as an object with keys
}
  
// Initial State
const initialState: FaqState = {
  faq: null,
};
  
const faqReducer = (
  state: FaqState = initialState,
  action: GetCmsEntryDataAction
) => {
  switch (action.type) {
    case GET_CMS_ENTRY_DATA_FAQ: {
      const { key, data } = action.payload;
      // Set the state of faq directly to an object with keys representing FAQ categories
      return {
        ...state,
        faq: {
          ...state.faq,
          [key]: data,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default faqReducer;
